<template>
    <div class="full-width list-box">
        <div class="record-box" v-for="(v, i) in list" :key="v.id">
            <quotationProductRecord :obj="v" @selectProduct="selectCallback" />
        </div>
    </div>
</template>

<script setup>
    import {inject} from "vue";
    import quotationProductRecord from "@/components/shopopee/quotation/quotationProductRecord"

    const props = defineProps(["list"])
    const emits = defineEmits(["selectProduct"])

    const i18n = inject("i18n")

    function selectCallback(flag, obj) {
        emits("selectProduct", flag, obj)
    }

</script>

<style scoped>
    .full-width {
        width: 100%;
    }

    .record-box {
        margin-bottom: 15px;
    }

    .list-box {
        padding: 10px;
        box-sizing: border-box;
    }
</style>